import googleLogo from '@atom/components/common/svgIcons/googleLogo.svg';
import { TenantConnection } from '@atom/hooks/useTenantConnections';

import { ssoConnectionConfig } from './ssoConnections';
import SsoLoginButton from './SsoLoginButton';

import classes from './login.module.css';

type SsoButtonGroupProps = {
  verb: string;
  connections: TenantConnection[];
};

const SsoButtonGroup = ({ verb, connections }: SsoButtonGroupProps) => (
  <div className={classes.registrationSocialLoginContainer}>
    <div className={classes.loginDecisionBreak}>
      <span>or</span>
    </div>
    <div className={classes.ssoButtonGroup}>
      <SsoLoginButton
        text={`${verb} with Google`}
        logo={googleLogo}
        connection="google-oauth2"
        prompt="select_account"
      />
      {connections.map(({ type, name }) => {
        const provider = ssoConnectionConfig[type];

        return provider ? (
          <SsoLoginButton
            key={type}
            text={`${verb} with ${provider.label}`}
            logo={provider.logo}
            connection={name}
          />
        ) : null;
      })}
    </div>
  </div>
);

export default SsoButtonGroup;
